<template>
  <div class="homeView">
    <!-- 头部 -->
    <TitleCom />
    <!-- banner 图/视频 -->
    <div class="banner">
      <img :src="bannerUrl" alt="" v-if="getMediaType(bannerUrl) === 'image'" />
      <video
        class="banner_video"
        autoplay
        muted
        loop
        playsinline
        v-if="getMediaType(bannerUrl) === 'video'"
      >
        <source type="video/mp4" :src="bannerUrl" />
      </video>
      <!-- banner 标题、内容 -->
      <div class="banner_title">
        <div class="title">{{ bannerVal.title }}</div>
        <div class="content">{{ bannerVal.content }}</div>
      </div>
    </div>
    <!-- 产品 -->
    <div class="product">
      <div class="product_title">{{ productVal.title }}</div>
      <div class="product_txt">{{ productVal.txt }}</div>
      <!-- 产品系列 -->
      <div class="product_list">
        <div
          class="product_dt"
          @click="toProductLine(ite.id)"
          v-for="(ite, ind) in productVal.list"
          :key="ind"
        >
          <div class="list_title">{{ ite.title }}</div>
          <img
            v-for="(items, inds) in ite.mediaList"
            :key="inds"
            :src="items.url"
            alt=""
          />
          <!-- <img src="../assets/img_home/datian.png" alt="" /> -->
          <div class="more">
            <div class="more_txt">了解更多</div>
            <img class="more_img" src="../assets/imgTwo/right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 服务 -->
    <div class="serve">
      <div class="serve_title">{{ serviceVal.title }}</div>
      <div class="serve_txt">{{ serviceVal.txt }}</div>
      <!-- 服务展示图 -->
      <div class="serve_list">
        <div
          class="serve_dt"
          v-for="(item, index) in serviceVal.list"
          :key="index"
        >
          <img :src="item.url" alt="" />
        </div>

        <!-- <div class="serve_dt">
          <img src="../assets/imgTwo/serve1.png" alt="" />
        </div>
        <div class="serve_dt">
          <img src="../assets/imgTwo/serve2.png" alt="" />
        </div>
        <div class="serve_dt">
          <img src="../assets/imgTwo/serve3.png" alt="" />
        </div>
        <div class="serve_dt">
          <img src="../assets/imgTwo/serve4.png" alt="" />
        </div> -->
      </div>
    </div>

    <!-- 优势 -->
    <div class="advantage">
      <div class="advantage_title">{{ advantageVal.title }}</div>
      <div class="advantage_txt">{{ advantageVal.txt }}</div>
      <img class="advantage_img" :src="advantageVal.imgUrl" alt="" />
      <div class="advantage_list">
        <img
          v-for="(ites, inde) in advantageVal.list"
          :key="inde"
          :class="inde % 2 === 0 ? 'imgs' : 'imgss'"
          :src="ites.url"
          alt=""
        />
      </div>
    </div>

    <!-- 底部 -->
    <AllFooter />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, reactive, computed } from "vue";
import TitleCom from "@/components/home/TitleCom.vue"; // @ is an alias to /src
import CarouselCom from "@/components/home/CarouselCom.vue";
import projectCom from "@/components/home/projectCom.vue";
import AllFooter from "@/components/footer/AllFooter.vue";
import { GetTypeValue, GetLinkIdDetail } from "@/api/api.js";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "HomeView",
  components: {
    TitleCom,
    CarouselCom,
    projectCom,
    AllFooter,
  },
  setup() {
    // banner
    let router = useRouter();
    const route = useRoute();
    // 过滤图片/视频
    const getMediaType = (url) => {
      if (/\.(mp4|mov|mkv|avi)$/i.test(url)) return "video";
      if (/\.(png|jpg|jpeg|gif|webp|heic)$/i.test(url)) return "image";
      return "other";
    };

    const bannerUrl = ref(""); //banner图地址
    const bannerVal = reactive({
      title: "会学习的农田作业机器人", //标题
      content: "用科技实现农业高效、高产、高品质", //内容
    });

    // 产品
    const productVal = reactive({
      title: "我们的产品", //标题
      txt: "", //内容
      list: [
        // { name: "园艺系列", imgurl: "../assets/img_home/datian.png" },
        // { name: "大田系列", imgurl: "../assets/img_home/datian.png" },
        // { name: "果林系列", imgurl: "../assets/img_home/datian.png" },
        // { name: "山地系列", imgurl: "../assets/img_home/datian.png" },
      ],
    });

    // 服务
    const serviceVal = reactive({
      title: "我们的服务", //标题
      txt: "", //内容
      list: [],
    });

    const advantageVal = reactive({
      title: "我们的优势", //标题
      txt: "",
      imgUrl: "",
      list: [
        // { imgurl: "../assets/imgTwo/saiga.png" },
        // { imgurl: "../assets/imgTwo/saiga.png" },
        // { imgurl: "../assets/imgTwo/saiga.png" },
        // { imgurl: "../assets/imgTwo/saiga.png" },
      ],
    });

    // 产品系列
    function toProductLine(e) {
      console.log(e, "当前系列id");
      router.push({
        path: "/ProductList",
        query: {
          id: e,
        },
      });
    }
    onMounted(() => {
      // 获取首页数据
      GetTypeValue(["homepage", "products", "services", "advantages"])
        .then((res) => {
          console.log(res, "首页数据");
          bannerUrl.value = res.data[0].mediaList[0].url;
          bannerVal.title = res.data[0].title;
          bannerVal.content = res.data[0].content;

          // 产品
          productVal.txt = res.data[1].content;
          // productVal.list = res.data[1].mediaList;

          //服务
          serviceVal.txt = res.data[2].content;
          serviceVal.list = res.data[2].mediaList;

          // 优势
          advantageVal.txt = res.data[3].content;
          advantageVal.imgUrl = res.data[3].mediaList[0].url;
          advantageVal.list = res.data[3].mediaList.slice(1);
        })
        .catch((err) => {
          console.log(err, "错误");
        });

      // 获取产品系列
      GetTypeValue(["ProductHomepage"])
        .then((res) => {
          console.log(res, "产品主页内容");
          if (res && res.code == 0) {
            if (res.data.length != 0) {
              GetLinkIdDetail(50, 1, res.data[0].id).then((ress) => {
                console.log(ress, "产品系列列表");
                if (ress && ress.code == 0) {
                  productVal.list = ress.data.list;
                  console.log(productVal.list, "产品系列数据");
                }
              });
            }
          }
        })
        .catch((err) => {
          console.log(err, "错误");
        });
    });

    return {
      bannerUrl,
      bannerVal,
      productVal,
      serviceVal,
      advantageVal,
      toProductLine,
      getMediaType
    };
  },
  methods: {
    handle() {
      let href = "https://beian.miit.gov.cn/#/Integrated/recordQuery"; //网站链接
      window.open(href, "_blank");
    },
  },
  created() {
    window.scrollTo(0, 0);
  },
});
</script>
<style lang="less" scoped>
.homeView {
  /* 隐藏滚动条箭头 */
  ::-webkit-scrollbar-button {
    display: none;
  }
  /* 自定义滚动条样式 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  width: 1920px;
  height: 100%;
  // banner
  .banner {
    position: relative;
    img {
      width: 1920px;
      height: 976px;
    }
    .banner_video {
      width: 1920px;
      height: 976px;
      object-fit: cover;
      /* 确保视频在容器中居中 */
      // object-position: center;
    }
    .banner_title {
      position: absolute;
      top: 355px;
      left: 435px;
      right: 20px;
      color: #e60012;
      letter-spacing: 1px;
      .title {
        width: fit-content; /* 宽度随文字内容自适应 */
        max-width: 100%; /* 如果标题太长，最多撑到父容器宽度，然后换行 */
        font-size: 80px;
        font-weight: 600;
        line-height: 70px;
        z-index: 1;
        padding-bottom: 35px;
        overflow-wrap: break-word;
        border-bottom: 5px solid #e60012;
      }
      .content {
        font-size: 38px;
        margin-top: 10px;
        overflow-wrap: break-word;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6; /* 显示几行后开始省略 */
        overflow: hidden;
      }
    }
  }

  // 我们的产品
  .product {
    width: 1781px;
    margin: 25px auto;
    cursor: pointer;
    overflow-wrap: break-word;

    .product_title {
      font-size: 40px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 25px;
      color: rgba(230, 0, 18, 1);
    }
    .product_txt {
      font-size: 28px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }
    .product_list {
      display: flex;
      overflow-y: auto;
      margin-top: 50px;
      padding-bottom: 5px;
      .product_dt {
        width: 390px;
        height: 390px;
        border-radius: 8px;
        margin-right: 45px;
        background-color: rgba(204, 204, 204, 1);
        .list_title {
          color: white;
          font-size: 30px;
          text-align: center;
          margin-top: 8px;
          width: 390px;
          //  强制文字在一行内显示，不换行
          white-space: nowrap;
          //  超出部分隐藏
          overflow: hidden;
          //  文本截断时显示省略号
          text-overflow: ellipsis;
        }
        img {
          width: 350px;
          height: 260px;
          margin-left: 32px;
        }
        .more {
          width: 217px;
          height: 53px;
          margin: 18px auto;
          display: flex;
          padding-top: 6px;
          border-radius: 15px;
          background-color: rgba(255, 255, 255, 0.2);
          .more_txt {
            color: white;
            font-size: 28px;
            margin-left: 42px;
          }
          .more_img {
            width: 28px;
            height: 28px;
            margin: 8px 0 0 5px;
          }
        }
      }
    }
  }

  // 我们的服务
  .serve {
    width: 1781px;
    margin: 25px auto;
    cursor: pointer;
    overflow-wrap: break-word;
    .serve_title {
      font-size: 40px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 37px;
      color: rgba(230, 0, 18, 1);
    }
    .serve_txt {
      font-size: 28px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }
    .serve_list {
      display: flex;
      margin-top: 50px;
      .serve_dt {
        width: 414px;
        height: 421px;
        border-radius: 8px;
        margin-right: 45px;
        img {
          width: 414px;
          height: 421px;
        }
      }
    }
  }

  // 我们的优势
  .advantage {
    width: 1781px;
    margin: 0 auto;
    margin-top: 25px;
    margin-bottom: 32px;
    cursor: pointer;
    overflow-wrap: break-word;
    .advantage_title {
      font-size: 48px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 30px;
      color: rgba(230, 0, 18, 1);
    }
    .advantage_txt {
      font-size: 28px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
    }
    .advantage_img {
      width: 1781px;
      height: 530px;
      margin-top: 50px;
    }
    .advantage_list {
      display: flex;
      flex-wrap: wrap;
      .imgs {
        width: 860px;
        height: 490px;
        margin-right: 40px;
        margin: 0 40px 30px 0;
      }
      .imgss {
        width: 860px;
        height: 490px;
        margin: 0 0 30px 0;
      }
    }
  }
}
</style>
